{
  "hero": {
    "title": "Transforme a Educação com IA",
    "subtitle": "Experiências de aprendizado personalizadas com inteligência artificial",
    "description": "O Sigma08 se adapta ao estilo único de aprendizado de cada aluno, fornecendo currículos personalizados e acompanhamento de progresso em tempo real para resultados educacionais ideais.",
    "cta": {
      "primary": "Teste Grátis",
      "secondary": "Ver Demonstração"
    }
  },
  "features": {
    "title": "Recursos Poderosos para Educação Moderna",
    "subtitle": "Tudo que você precisa para melhorar os resultados de aprendizagem",
    "list": {
      "aiPersonalization": {
        "title": "Personalização com IA",
        "description": "Caminhos de aprendizado adaptativos que se ajustam ao ritmo e compreensão de cada aluno"
      },
      "progressTracking": {
        "title": "Acompanhamento em Tempo Real",
        "description": "Monitore o progresso do aluno com análises e insights detalhados"
      },
      "curriculumManagement": {
        "title": "Gestão Inteligente de Currículo",
        "description": "Otimização automática do currículo baseada nos resultados de aprendizagem"
      },
      "parentEngagement": {
        "title": "Ferramentas para Pais",
        "description": "Mantenha os pais informados e envolvidos na educação de seus filhos"
      },
      "assessmentTools": {
        "title": "Avaliação Completa",
        "description": "Múltiplos tipos de avaliação com feedback e correção instantâneos"
      },
      "collaboration": {
        "title": "Aprendizado Colaborativo",
        "description": "Promova interação entre pares e atividades de aprendizado em grupo"
      }
    }
  },
  "pricing": {
    "title": "Escolha Seu Plano",
    "subtitle": "Preços flexíveis para escolas e famílias",
    "monthly": "Mensal",
    "annual": "Anual",
    "savePercent": "Economize {{percent}}%",
    "currency": "BRL",
    "plans": {
      "starter": {
        "name": "Inicial",
        "price": 149,
        "period": "por aluno/mês",
        "description": "Perfeito para famílias individuais",
        "features": [
          "Até 3 alunos",
          "Acesso ao currículo básico",
          "Acompanhamento básico",
          "Suporte por email",
          "Acesso ao app móvel"
        ],
        "cta": "Teste Grátis"
      },
      "professional": {
        "name": "Profissional",
        "price": 249,
        "period": "por aluno/mês",
        "description": "Ideal para escolas pequenas",
        "popular": true,
        "features": [
          "Até 30 alunos",
          "Biblioteca completa",
          "Análises avançadas",
          "Suporte prioritário",
          "Avaliações personalizadas",
          "Portal para pais"
        ],
        "cta": "Teste Grátis"
      },
      "enterprise": {
        "name": "Empresarial",
        "price": "Personalizado",
        "period": "entre em contato",
        "description": "Para grandes instituições",
        "features": [
          "Alunos ilimitados",
          "Currículo personalizado",
          "Opções white-label",
          "Suporte dedicado",
          "Acesso à API",
          "Treinamento e integração"
        ],
        "cta": "Falar com Vendas"
      }
    }
  },
  "testimonials": {
    "title": "O Que Educadores Estão Dizendo",
    "subtitle": "Junte-se a milhares de professores e pais satisfeitos",
    "list": [
      {
        "quote": "O Sigma08 revolucionou nossa abordagem ao aprendizado personalizado na escola.",
        "author": "Maria Silva",
        "role": "Diretora",
        "organization": "Colégio São Paulo"
      },
      {
        "quote": "As recomendações de IA ajudaram minha filha a melhorar suas notas em matemática em 40%.",
        "author": "João Santos",
        "role": "Pai",
        "organization": "Pai de aluna do 8º ano"
      },
      {
        "quote": "Finalmente, uma plataforma que se adapta ao estilo único de aprendizado de cada aluno.",
        "author": "Ana Costa",
        "role": "Professora",
        "organization": "Escola Municipal Rio"
      }
    ]
  },
  "cta": {
    "title": "Pronto para Transformar sua Educação?",
    "subtitle": "Junte-se a milhares de escolas e famílias usando o Sigma08",
    "button": "Comece seu Teste Grátis",
    "trial": "14 dias grátis • Sem cartão de crédito • Cancele quando quiser"
  },
  "stats": {
    "students": {
      "value": "50.000+",
      "label": "Alunos Ativos"
    },
    "schools": {
      "value": "500+",
      "label": "Escolas Parceiras"
    },
    "improvement": {
      "value": "35%",
      "label": "Melhoria Média nas Notas"
    },
    "satisfaction": {
      "value": "98%",
      "label": "Taxa de Satisfação"
    }
  }
}
